module.exports = __webpack_public_path__ + "img/23.36ee9093.png";